var map = {
	"./Australian/10 bold 1.svg": 49397,
	"./Australian/7Mate Brisbane.svg": 77668,
	"./Australian/7Mate Melbourne.svg": 85555,
	"./Australian/7Mate Sydney.svg": 1638,
	"./Australian/7TWO 1.svg": 14516,
	"./Australian/7TWO Brisbane.svg": 81654,
	"./Australian/7TWO Melbourne.svg": 4559,
	"./Australian/7TWO Perth.svg": 90894,
	"./Australian/7TWO Sydney.svg": 97910,
	"./Australian/7mate Adelaide 1.svg": 57370,
	"./Australian/7mate Perth.svg": 37891,
	"./Australian/9Gem 1.svg": 30165,
	"./Australian/9go 1.svg": 83081,
	"./Australian/ABC 1.svg": 96124,
	"./Australian/ABC QLD.svg": 98515,
	"./Australian/ABC SA.svg": 34643,
	"./Australian/ABC VIC.svg": 57864,
	"./Australian/ABC WA.svg": 73728,
	"./Australian/Australia Plus 1.svg": 32063,
	"./Australian/Channel 10 Brisbane.svg": 31505,
	"./Australian/Channel 10 Melbourne.svg": 29267,
	"./Australian/Channel 10 Perth.svg": 83644,
	"./Australian/Channel 10 Sydney.svg": 75066,
	"./Australian/Channel 10.svg": 25953,
	"./Australian/Channel 7 Brisbane.svg": 4174,
	"./Australian/Channel 7 Melbourne.svg": 5786,
	"./Australian/Channel 7 Perth.svg": 15514,
	"./Australian/Channel 7 Sydney.svg": 97993,
	"./Australian/Channel 7.svg": 92971,
	"./Australian/Channel 9 Brisbane.svg": 44542,
	"./Australian/Channel 9 Melbourne.svg": 49953,
	"./Australian/Channel 9 Perth.svg": 44164,
	"./Australian/Channel 9 Sydney.svg": 23784,
	"./Australian/Channel 9.svg": 22393,
	"./Australian/Chelsea TV.svg": 19777,
	"./Australian/ESPN.svg": 98614,
	"./Australian/ESPN2.svg": 59266,
	"./Australian/Epicentre.TV.svg": 91535,
	"./Australian/Eurosport.svg": 63629,
	"./Australian/Fox Cricket.svg": 83052,
	"./Australian/Fox Footy.svg": 60502,
	"./Australian/Fox League.svg": 82320,
	"./Australian/Fox Sports 503.svg": 7493,
	"./Australian/Fox Sports 505.svg": 76501,
	"./Australian/Fox Sports 506.svg": 9104,
	"./Australian/Fox Sports More.svg": 36007,
	"./Australian/Fox Ultra HD.svg": 12930,
	"./Australian/Kayo Sports.svg": 84345,
	"./Australian/LFCTV.svg": 80497,
	"./Australian/MUTV.svg": 25951,
	"./Australian/Main Event.svg": 17596,
	"./Australian/NITV.svg": 67869,
	"./Australian/Netball Live.svg": 64034,
	"./Australian/Optus sport.svg": 45457,
	"./Australian/RAI Italia.svg": 63987,
	"./Australian/Racing.com.svg": 4649,
	"./Australian/SBS SA.svg": 71162,
	"./Australian/SBS Sydney.svg": 41479,
	"./Australian/SBS Viceland.svg": 98223,
	"./Australian/SBS WA.svg": 93150,
	"./Australian/SBS.svg": 19904,
	"./Australian/SKY Racing 2.svg": 89606,
	"./Australian/SKY Racing.svg": 80832,
	"./Australian/Sport Plus TV.svg": 27794,
	"./Australian/Stan Sport.svg": 79320,
	"./Australian/TV5MONDE Pacific.svg": 63756,
	"./Australian/Telstra TV.svg": 31817,
	"./Australian/beIN SPORTS 2.svg": 53755,
	"./Australian/beIN SPORTS 3.svg": 19097,
	"./Australian/beIN SPORTS.svg": 66213,
	"./Danish/3-Max.svg": 84538,
	"./Danish/3-Plus.svg": 85730,
	"./Danish/3-Sport.svg": 19009,
	"./Danish/6-eren.svg": 93454,
	"./Danish/9-eren.svg": 8205,
	"./Danish/C-More.svg": 59793,
	"./Danish/Canal-8-Sport.svg": 60314,
	"./Danish/DR1.svg": 71122,
	"./Danish/DR2.svg": 16544,
	"./Danish/DR3.svg": 57528,
	"./Danish/Eurosport-1.svg": 41091,
	"./Danish/Eurosport-2.svg": 93411,
	"./Danish/Eurosport-Player.svg": 60498,
	"./Danish/Kanal-5.svg": 99107,
	"./Danish/See.svg": 4579,
	"./Danish/Strive.svg": 44547,
	"./Danish/TV2-Sport.svg": 16080,
	"./Danish/TV2.svg": 25065,
	"./Danish/TV3-Sport-2.svg": 34329,
	"./Danish/Viasat-Golf.svg": 56475,
	"./Danish/Viasat-Xtra.svg": 23358,
	"./Danish/Xee.svg": 34374,
	"./Danish/dPlay.svg": 83672,
	"./Danish/viaplay.svg": 18769,
	"./Finland/C More Golf.svg": 89566,
	"./Finland/C More Max.svg": 53269,
	"./Finland/C More Sport 1.svg": 42363,
	"./Finland/C More Sport 2.svg": 88442,
	"./Finland/Elisa Viihde Sport.svg": 38470,
	"./Finland/Eurosport 2.svg": 37838,
	"./Finland/Eurosport.svg": 6201,
	"./Finland/MTV3.svg": 44511,
	"./Finland/Ruutu+ Urheliu 1.svg": 38842,
	"./Finland/Ruutu+ Urheliu 2.svg": 39755,
	"./Finland/Ruutu+ Urheliu 3.svg": 2683,
	"./Finland/Ruutu+ Urheliu 4.svg": 68280,
	"./Finland/Ruutu+ Urheliu 5.svg": 32495,
	"./Finland/Ruutu+ Urheliu 6.svg": 97664,
	"./Finland/Ruutu+ Urheliu 7.svg": 33221,
	"./Finland/Ruutu+ Urheliu 8.svg": 30186,
	"./Finland/Ruutu+.svg": 86069,
	"./Finland/Sub.svg": 65017,
	"./Finland/Telia.svg": 9241,
	"./Finland/Unibet TV.svg": 77288,
	"./Finland/Viasat Fotboll.svg": 99027,
	"./Finland/Viasat Golf.svg": 71925,
	"./Finland/Viasat Hockey.svg": 68443,
	"./Finland/Viasat Jalkapallo.svg": 54925,
	"./Finland/Viasat Jääkiekko.svg": 22119,
	"./Finland/Viasat Sport Live 1.svg": 84053,
	"./Finland/Viasat Sport Live 2.svg": 47349,
	"./Finland/Viasat Sport Live 3.svg": 2786,
	"./Finland/Viasat Sport Live 4.svg": 10404,
	"./Finland/Viasat Sport Live 5.svg": 86607,
	"./Finland/Viasat Sport Premium.svg": 75185,
	"./Finland/Viasat Sport Ultra HD.svg": 57344,
	"./Finland/Viasat Sport.svg": 9504,
	"./Finland/Viasat Urheilu.svg": 21357,
	"./Finland/YLE Areena.svg": 31127,
	"./Finland/Yle FEM.svg": 59167,
	"./Finland/Yle TV1.svg": 54396,
	"./Finland/Yle TV2.svg": 53143,
	"./Germany/ARD-alpha.svg": 19747,
	"./Germany/Amazon Prime DE.svg": 2947,
	"./Germany/BR.svg": 53028,
	"./Germany/DAZN.svg": 49433,
	"./Germany/Das Erste.svg": 92316,
	"./Germany/Einsfestival.svg": 5897,
	"./Germany/Eurosport 1.svg": 87230,
	"./Germany/Eurosport 2 Xtra.svg": 38223,
	"./Germany/Eurosport 2.svg": 35881,
	"./Germany/Eurosport Player DE.svg": 57835,
	"./Germany/HR.svg": 49981,
	"./Germany/Hamburg 1.svg": 16153,
	"./Germany/Kabel eins.svg": 33577,
	"./Germany/LAOLA1.svg": 72570,
	"./Germany/MDR.svg": 93749,
	"./Germany/Magenta Sport.svg": 96269,
	"./Germany/Motorvision TV.svg": 96438,
	"./Germany/N-TV.svg": 31230,
	"./Germany/NDR.svg": 94478,
	"./Germany/ProSieben Fun.svg": 3726,
	"./Germany/ProSieben MAXX.svg": 3258,
	"./Germany/RBB.svg": 88244,
	"./Germany/RTL II.svg": 80519,
	"./Germany/RTL NITRO.svg": 56748,
	"./Germany/RTL.svg": 86976,
	"./Germany/SAT.1 Gold.svg": 62662,
	"./Germany/SAT.1.svg": 68897,
	"./Germany/SPORT1+.svg": 77297,
	"./Germany/SPORT1.svg": 23681,
	"./Germany/SR Fernsehen.svg": 32233,
	"./Germany/SWR BW.svg": 13680,
	"./Germany/SWR RP.svg": 41384,
	"./Germany/SWR.svg": 90532,
	"./Germany/ServusTV Deutschland.svg": 20702,
	"./Germany/Sky Bundesliga 1.svg": 44933,
	"./Germany/Sky Bundesliga 2.svg": 84499,
	"./Germany/Sky Bundesliga 3.svg": 58840,
	"./Germany/Sky Bundesliga 4.svg": 11048,
	"./Germany/Sky Bundesliga 5.svg": 13602,
	"./Germany/Sky Bundesliga 6.svg": 62417,
	"./Germany/Sky Bundesliga 7.svg": 27346,
	"./Germany/Sky Bundesliga 8.svg": 40139,
	"./Germany/Sky Bundesliga 9.svg": 32599,
	"./Germany/Sky Bundesliga UHD.svg": 11742,
	"./Germany/Sky Bundesliga.svg": 83469,
	"./Germany/Sky Sport 1.svg": 8329,
	"./Germany/Sky Sport 10.svg": 29014,
	"./Germany/Sky Sport 11.svg": 25757,
	"./Germany/Sky Sport 2.svg": 78073,
	"./Germany/Sky Sport 3.svg": 13748,
	"./Germany/Sky Sport 4.svg": 26311,
	"./Germany/Sky Sport 5.svg": 4476,
	"./Germany/Sky Sport 6.svg": 98312,
	"./Germany/Sky Sport 7.svg": 65772,
	"./Germany/Sky Sport 8.svg": 92005,
	"./Germany/Sky Sport 9.svg": 92150,
	"./Germany/Sky Sport News.svg": 41412,
	"./Germany/Sky Ticket.svg": 71395,
	"./Germany/Sky Ultra HD.svg": 38762,
	"./Germany/Sportdeutschland.TV.svg": 69230,
	"./Germany/Sportdigital.svg": 59517,
	"./Germany/TV5MONDE Europe.svg": 20875,
	"./Germany/TVNOW.svg": 17698,
	"./Germany/WDR.svg": 89213,
	"./Germany/ZDF.svg": 52981,
	"./Germany/eSports1.svg": 94015,
	"./NewZealand/Duke.svg": 94198,
	"./NewZealand/ESPN 2.svg": 49384,
	"./NewZealand/ESPN.svg": 82185,
	"./NewZealand/Prime.svg": 95463,
	"./NewZealand/Rugby Channel.svg": 36063,
	"./NewZealand/SKY Sport Pop Up 1.svg": 34789,
	"./NewZealand/SKY Sport Pop Up 2.svg": 45692,
	"./NewZealand/Sky Arena.svg": 23201,
	"./NewZealand/Sky Sport 2.svg": 94147,
	"./NewZealand/Sky Sport 3.svg": 92957,
	"./NewZealand/Sky Sport 4.svg": 52081,
	"./NewZealand/Sky Sport 5.svg": 68339,
	"./NewZealand/Sky Sport 6.svg": 98120,
	"./NewZealand/Sky Sport 7.svg": 93761,
	"./NewZealand/Sky Sport 8.svg": 85285,
	"./NewZealand/Sky Sport 9.svg": 86616,
	"./NewZealand/Sky Sport Select.svg": 66754,
	"./NewZealand/Sky Sport.svg": 11766,
	"./NewZealand/Spark Sport.svg": 30316,
	"./NewZealand/TV5MONDE Pacific.svg": 82432,
	"./NewZealand/TVNZ+.svg": 98581,
	"./NewZealand/Trackside 1.svg": 74133,
	"./NewZealand/Trackside 2.svg": 81915,
	"./NewZealand/beIN SPORTS 2.svg": 10076,
	"./NewZealand/beIN SPORTS 3.svg": 18484,
	"./NewZealand/beIN SPORTS Pop-up 2.svg": 73570,
	"./NewZealand/beIN SPORTS Pop-up.svg": 74360,
	"./NewZealand/beIN SPORTS XTRA.svg": 64578,
	"./NewZealand/beIN SPORTS.svg": 50608,
	"./Norway/Betsafe NO.svg": 69438,
	"./Norway/Betsson NO.svg": 6262,
	"./Norway/Direktesport.svg": 49866,
	"./Norway/ESportsTV.svg": 49482,
	"./Norway/Eurosport 1.svg": 86008,
	"./Norway/Eurosport Norge.svg": 70469,
	"./Norway/Eurosport Player NO.svg": 26524,
	"./Norway/Eurosport Pluss 1.svg": 55120,
	"./Norway/Eurosport Pluss 2.svg": 48406,
	"./Norway/Eurosport Pluss 3.svg": 555,
	"./Norway/Eurosport Pluss 4-1.svg": 18310,
	"./Norway/Eurosport Pluss 4.svg": 19634,
	"./Norway/MAX.svg": 10150,
	"./Norway/NRK 1.svg": 23125,
	"./Norway/NRK 2.svg": 16631,
	"./Norway/NRK 3.svg": 45114,
	"./Norway/Strive Sport TV.svg": 10996,
	"./Norway/Strive Sport.svg": 6666,
	"./Norway/Strive.svg": 9691,
	"./Norway/TV 2 Sport 1.svg": 26146,
	"./Norway/TV 2 Sport 2.svg": 66001,
	"./Norway/TV 2 Sport Premium 2.svg": 24669,
	"./Norway/TV 2 Sport Premium 3.svg": 27539,
	"./Norway/TV 2 Sport Premium.svg": 37114,
	"./Norway/TV 2 Sportskanalen.svg": 12933,
	"./Norway/TV 2 Zebra.svg": 32265,
	"./Norway/TV 2.svg": 94088,
	"./Norway/TV2 Sumo.svg": 18675,
	"./Norway/TVNorge.svg": 53041,
	"./Norway/V Sport +.svg": 70740,
	"./Norway/V Sport Live 1.svg": 41380,
	"./Norway/V Sport Live 2.svg": 49553,
	"./Norway/V Sport Live 3.svg": 12065,
	"./Norway/V Sport Live 4.svg": 51037,
	"./Norway/V Sport Live 5.svg": 70472,
	"./Norway/VG+.svg": 43650,
	"./Norway/VOX.svg": 48375,
	"./Norway/Viaplay Kjøp.svg": 26006,
	"./Norway/Viasat 4.svg": 56579,
	"./Norway/Viasat Golf.svg": 86405,
	"./Norway/Viasport +.svg": 98409,
	"./Norway/Viasport 1.svg": 10421,
	"./Norway/Viasport 2.svg": 10904,
	"./Norway/Viasport 3.svg": 37809,
	"./Norway/Viasport Ultra HD.svg": 80102,
	"./Swedish/ATG.svg": 29088,
	"./Swedish/Aftonbladet Plus.svg": 79866,
	"./Swedish/Bet 365.svg": 5665,
	"./Swedish/C More Fotboll.svg": 58848,
	"./Swedish/C More Hockey.svg": 19733,
	"./Swedish/C More Live 1.svg": 49608,
	"./Swedish/C More Live 2.svg": 48374,
	"./Swedish/C More Live 3.svg": 73078,
	"./Swedish/C More Live 4 1.svg": 78130,
	"./Swedish/C More Live 4.svg": 4693,
	"./Swedish/Hajper.svg": 41049,
	"./Swedish/Kanal 5.svg": 44723,
	"./Swedish/Kanal 9.svg": 20808,
	"./Swedish/Kunskapskanalen.svg": 74504,
	"./Swedish/SVT 24.svg": 19218,
	"./Swedish/SVT Play.svg": 81087,
	"./Swedish/SVT1.svg": 74126,
	"./Swedish/SVT2.svg": 42946,
	"./Swedish/Sjuan.svg": 49245,
	"./Swedish/Sport Expressen.svg": 16529,
	"./Swedish/Sport Kanalen.svg": 49283,
	"./Swedish/TV 12.svg": 79918,
	"./Swedish/TV 4.svg": 83981,
	"./Swedish/TV 6.svg": 7935,
	"./Swedish/TV10.svg": 3802,
	"./Swedish/TV3 Sport.svg": 66293,
	"./Swedish/Tv 3.svg": 49080,
	"./Swedish/Tv4 play.svg": 9792,
	"./Swedish/V Sport ultra hd 1.svg": 62264,
	"./Swedish/V sport football 1.svg": 38731,
	"./Swedish/V sport hockey 1.svg": 86697,
	"./Swedish/VSport1.svg": 60162,
	"./Swedish/VSportMotor.svg": 37506,
	"./Swedish/VSport_premium.svg": 86797,
	"./Swedish/Viasat Sport Extra.svg": 50433,
	"./Swedish/sportbladet play.svg": 31839,
	"./UK/Amazon-Prime.svg": 22126,
	"./UK/BBC-Alba.svg": 22882,
	"./UK/BBC-Northern-Ireland.svg": 4671,
	"./UK/BBC-Red-Button.svg": 82785,
	"./UK/BBC-Scotland.svg": 76762,
	"./UK/BBC-Sport.svg": 34429,
	"./UK/BBC-Wales.svg": 9274,
	"./UK/BBC.svg": 21580,
	"./UK/BT-Sport-1.svg": 47838,
	"./UK/BT-Sport-2.svg": 26005,
	"./UK/BT-Sport-3.svg": 92699,
	"./UK/BT-Sport.svg": 68008,
	"./UK/Channel-4.svg": 74329,
	"./UK/Channel-5.svg": 18014,
	"./UK/Eleven-Sports.svg": 19674,
	"./UK/Eurosport.svg": 62767,
	"./UK/FreeSports.svg": 79844,
	"./UK/ITV-4.svg": 8658,
	"./UK/ITV-Sport.svg": 57209,
	"./UK/ITV.svg": 70045,
	"./UK/Premier-Sports.svg": 51858,
	"./UK/Prime-Video.svg": 49692,
	"./UK/Quest.svg": 77456,
	"./UK/Racing-TV.svg": 78020,
	"./UK/S4C.svg": 53983,
	"./UK/Sky-Sports-F1.svg": 76370,
	"./UK/Sky-Sports-Racing.svg": 8458,
	"./UK/Sky-Sports.svg": 10609,
	"./UK/Star-India.svg": 90350,
	"./UK/UEFA.svg": 59890,
	"./UK/Youtube.svg": 72469,
	"./default.svg": 92577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31617;